<template>
  <div class="popup-conditions-credit popup-all">
      <div class="popup-container">
        <div class="popup-vue condition-credit">
          <img class="popup-close" src="/img/credit-landing-vue/popup-close.svg" alt="Close" @click="popupClose()">
          <div class="popup-title" v-if="contentLoaded" v-html="title"></div>
          <div class="popup-description" v-if="contentLoaded" v-html="description"></div>
          <div v-else class="popup-spinner"></div>
        </div>
      </div>
  </div>
</template>
<script>
    export default {
        name: "popup_conditions-credit",
        data() {
          return {
            title: "",
            description: '',
            contentLoaded: false
          }
        },
        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            popupShow: function () {
                this.$el.style.display = 'block';
                if (!this.contentLoaded) {
                  this.getContent();
                }
            },
            popupClose: function () {
                this.$el.style.display = 'none';
            },
          getContent: function () {
            const self = this;
            jQuery.ajax({
              headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
              },
              type: "GET",
              url: '/cash/cash-document',
              cache: false,
              dataType: "json",
              success: function (response) {
                self.title = response.title;
                self.description = response.description;
                self.contentLoaded = true;
              },
              error: function (error) {

              }
            });
          }
        }
    }
</script>
